require('./_wks-define')('asyncIterator');



//////////////////
// WEBPACK FOOTER
// /Users/qixian.cs/Documents/GitHub/ant-design-pro-site/scaffold/node_modules/core-js/library/modules/es7.symbol.async-iterator.js
// module id = 461
// module chunks = 0